import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-montserrat';
import {Row, Col} from 'antd'
import NumbersBreakdownBlock from './Containers/ProductDetailsPage/components/NumbersBreakdownBlock'

import './index.less';
import './App.less';

ReactDOM.render(
  <Row
    gutter={[
      {xs: 0, sm: 0, md: 16},
      {xs: 0, sm: 0, md: 16},
    ]}
    className={'theme-light'}
  >
    <Col span={24} id="product-details-block-numbers-id">
      <NumbersBreakdownBlock
        product={null}
        theme={'light'}
        isMobile={false}
        skeleton={false}
      />
    </Col>
  </Row>,
  document.getElementById('numbers-breakdown-root')
);
